// fr.js

export const fr = {
    menu: {
        about: "À propos",
        privacy: "Confidentialité",
        terms: "Conditions",
        contactUs: "Contactez-nous",
        DazWayWeb: "{{APP_NAME}} Web",
        home: "Accueil",
        help: "Aide",
        policy: "Politique",
        policySubMenu: {
            staySafe: "Restez en sécurité",
            childProtection: "Protection de l’enfance"
        },
        helpSubMenu: {
            deleteAccount: "Supprimer le compte",
            manageProfile: "Gérer le profil",
            featuresToCommunicate: "Fonctionnalités de communication",
            profileCreation: "Création du profil",
            editProfileFeatures: "Modifier les fonctionnalités du profil",
            createAndSharePost: "Chats",
            exploreAndViewPost: "Appels",
            chatsAndCalls: "Réunions",
            updateAccount: "Mettre à jour les paramètres du compte",
            interest: "Modifier les centres d’intérêt du fil d’accueil",
            notification: "Paramètres des notifications",
            language: "Changer la langue",
            linkAccount: "Lier le compte à la page Web",
            inviteFriends: "Inviter vos amis",
            logout: "Se déconnecter de DazWay",
            settings: "Ajuster vos paramètres"
        }
    },
    pages: {
        contactUs: {
            title: "Contactez-nous",
            desc: "Nous sommes là pour vous aider ! Si vous avez des questions, des commentaires ou si vous avez besoin d'aide, n'hésitez pas à nous contacter. Vous pouvez nous joindre par l'une des méthodes suivantes "
        },
        address: {
            label: "Adresse postale",
            value1: "DazWay Pay",
            value2: "7 Bell Yard, Londres, Angleterre, WC2A 2JR"
        },
        home: {
            mainBanner: {
                title: "Restez connecté à tout moment, n'importe où",
                desc: "Connectez-vous avec vos amis, votre famille ou vos coéquipiers — de manière fluide et sécurisée.",
                features: {
                    chatInstantly: "Discutez instantanément",
                    crystalClearCalls: "Appels d'une clarté cristalline",
                    hdVideoAnywhere: "Vidéo HD n'importe où"
                },
                cardSection1: {
                    title: "Connectez-vous de manière fluide, à tout moment, n'importe où",
                    desc: "Messagerie en temps réel avec photos, émojis et plus encore. Vos conversations, à votre façon — le tout au même endroit."
                },
                cardSection2: {
                    title: "Partagez en toute confiance avec le chiffrement de bout en bout",
                    desc: "Parlez librement — vos messages, appels et chats vidéo sont protégés par un puissant chiffrement de bout en bout."
                },
                cardSection3: {
                    title: "Restez proches, quelle que soit la distance",
                    desc: "Qu'il s'applique à un appel de groupe ou un simple bonjour, profitez d'appels vocaux et vidéo de haute qualité qui vous rapprochent."
                }
            },
            banner1: {
                title: "Ne manquez jamais un moment grâce aux appels vocaux et vidéo",
                desc: "Des appels de groupe avec vos amis aux appels rapides avec la famille, profitez d'appels vocaux et vidéo d'une clarté cristalline qui vous donnent l'impression d'être dans la même pièce."
            },
            banner2: {
                title: "Restez proches, quelle que soit la distance",
                desc: "Plongez dans un monde de photos, de vidéos et de profils adaptés à vos centres d'intérêt. Découvrez et connectez-vous à de nouveaux contenus sans effort."
            },
            banner3: {
                title: "Capturez et partagez vos moments du quotidien",
                desc: "D'un appel de groupe avec des camarades de classe à un appel rapide avec maman, sentez-vous dans la même pièce grâce aux appels vocaux et vidéo."
            }
        }
    },
    genericContent: {
        email: "E-mail",
        phoneNumber: "Numéro de téléphone",
        joinDaz: "Rejoignez {{APP_NAME}}",
        mailingAddress: "Adresse postale",
        note: "Remarque",
        or: "OU"
    },

    aboutPage: {
        title: "À propos de DazWay",

        heading:
            "Bienvenue sur l’application DazWay – Redéfinir une communication sécurisée et expressive",

        description:
            "L’application DazWay est une plateforme de nouvelle génération pour une communication numérique fluide, sécurisée et expressive. Que vous soyez en contact avec vos amis, votre famille ou vos collègues, DazWay offre une expérience raffinée avec une messagerie en temps réel, des appels audio/vidéo haute définition et des fonctionnalités de partage intelligentes — le tout dans une interface moderne et élégante.",

        keyFeatures: "Fonctionnalités principales :",

        features: {
            realTimeMessaging: {
                title: "Messagerie en temps réel",
                desc:
                    "Discutez instantanément avec des indicateurs de saisie, des confirmations de lecture et un flux de messages fluide.",
            },

            hdCalls: {
                title: "Appels audio et vidéo HD",
                desc:
                    "Passez des appels audio et vidéo de haute qualité avec chiffrement de bout en bout depuis n’importe où dans le monde.",
            },

            mediaSharing: {
                title: "Partage de médias et de fichiers",
                desc:
                    "Partagez facilement des photos, vidéos, notes vocales et documents en quelques clics.",
            },

            emojis: {
                title: "Émojis et réactions",
                desc:
                    "Exprimez-vous avec une grande variété d’émojis et de réactions instantanées aux messages.",
            },

            liveLocation: {
                title: "Partage de position en direct",
                desc:
                    "Partagez votre position en temps réel avec des contacts de confiance pour plus de commodité et de sécurité.",
            },

            modernUi: {
                title: "UI/UX moderne",
                desc:
                    "Profitez d’un design rapide, intuitif et épuré, adapté à un usage personnel et professionnel.",
            },

            scheduledMessages: {
                title: "Messages programmés",
                desc:
                    "Planifiez et envoyez automatiquement des messages à la date et à l’heure de votre choix sans manquer de conversations importantes.",
            },

            disappearingMessages: {
                title: "Messages éphémères",
                desc:
                    "Gardez vos discussions privées en supprimant automatiquement les messages après la durée sélectionnée.",
            },

            editingTools: {
                title: "Outils d’édition de base",
                desc:
                    "Modifiez et personnalisez vos photos et vidéos avec des outils simples comme le recadrage, la rotation, le dessin et le texte avant le partage.",
            },

            frenchLocalization: {
                title: "Localisation française",
                desc:
                    "Profitez de l’interface de l’application en français avec des menus, libellés, messages et parcours utilisateur localisés pour une meilleure accessibilité et expérience utilisateur.",
            },
        },

        footerDescription:
            "L’application DazWay est bien plus qu’un simple outil de discussion — c’est votre compagnon numérique sécurisé, conçu pour protéger votre vie privée et améliorer votre façon de communiquer.",

        downloadText:
            "Téléchargez l’application DazWay dès aujourd’hui et découvrez l’avenir de la communication numérique.",
    },
    privacy: {
        title: "Politique de confidentialité",

        introduction: {
            title: "1. Introduction",

            englishNotLegalese: {
                title: "1.1 Anglais simple, pas jargon juridique",
                desc1:
                    "La confidentialité est importante et nous voulons que vous compreniez les sujets concernés.",
                desc2:
                    "Lorsque vous voyez 'DazWay', cela fait référence à tous les services disponibles sur",
                service1:
                    "L'application de chat DazWay.",
                service2:
                    "L'application de communication des développeurs Pareza Limited.",
                service3:
                    "L'achat, la configuration et la gestion des serveurs hébergés.",
                homeserver:
                    "Le terme 'homeserver' désigne les services configurés dans DazWay.",
                serviceDescBefore:
                    "Lorsque vous lisez 'le Service' dans ce document, cela fait référence aux instances de chat DazWay exposées sur",
                serviceDescAfter:
                    "(ou sous-domaines) par Pareza Limited.",
                companyDesc:
                    "DazWay est un nom commercial de Pareza Limited.",
                controller:
                    "DazWay est le responsable du traitement de vos données.",
                contact:
                    "Pour toute question, veuillez nous envoyer un e-mail.",
                postalAddress:
                    "Adresse postale : DazWay Pay, 7 Bell Yard, Londres, Angleterre, WC2A 2JR",
            },

            scope: {
                title: "1.2 Portée de ce document",
                desc:
                    "Ce document explique comment nous traitons les données personnelles.",
                user:
                    "Les utilisateurs de DazWay utilisent l'application pour se connecter aux serveurs compatibles SCPT.",
                customer:
                    "Les clients DazWay utilisent les services SCPT pour gérer les serveurs hébergés.",
            },

            customerUser: {
                title: "1.3 Le Client et l'Utilisateur",
                desc1:
                    "Vous êtes un Client si vous payez DazWay pour un service dédié.",
                desc2:
                    "Vous êtes un Utilisateur si vous utilisez DazWay pour envoyer et recevoir des messages.",
            },

            changes: {
                title: "1.4 Modifications de ce document",
                desc1:
                    "Nous pouvons modifier ce document au fil du temps.",
                desc2:
                    "Votre utilisation de DazWay est toujours soumise à la version actuelle.",
            },
        },

        accessData: {
            title: "2. Accès à vos données",

            legalBasis: {
                title:
                    "2.1 Quelle est la base légale du traitement de mes données ?",
                subTitle:
                    "2.1.1 Base légale du traitement",
                desc:
                    "DazWay applique différentes bases légales selon le produit utilisé.",
                chatUsers:
                    "Nous collectons votre adresse IP lorsque vous accédez au client DazWay.",
            },

            dataOwnership: {
                title:
                    "2.1.2 Propriété des données",
                desc1:
                    "Le client possède et contrôle les messages et fichiers.",
                desc2:
                    "Les messages non chiffrés peuvent être accessibles au client.",
            },

            rights: {
                title:
                    "2.1.3 Vos droits en tant que personne concernée",
                desc:
                    "Vous disposez de droits concernant vos données personnelles.",
                right1: "Le droit d'être informé",
                right2: "Le droit d'accès",
                right3: "Le droit de rectification",
                right4: "Le droit à l'effacement",
                right5: "Le droit à la limitation du traitement",
                right6: "Le droit à la portabilité des données",
                right7: "Le droit d'opposition",
                right8:
                    "Les droits liés à la prise de décision automatisée",
                right9:
                    "Pour plus d’informations sur ces droits, veuillez consulter les directives fournies par l’ICO. Si vous avez des questions ou si vous ne savez pas comment exercer vos droits, veuillez nous contacter à",
            },

            collectInfo: {
                title:
                    "2.2 Quelles informations collectons-nous et pourquoi ?",
                desc:
                    "Les informations collectées servent à améliorer et maintenir nos services.",
            },

            profileInfo: {
                title: "2.2.1 Informations que vous nous fournissez :",
                desc: "Nous collectons des informations vous concernant lorsque vous les saisissez dans les applications DazWay ou SCPT Services, ou lorsque vous nous les fournissez directement.",
                subTitle: "Informations de profil DazWay",
                desc1: "Lorsque vous vous inscrivez et utilisez notre application, nous pouvons collecter les informations personnelles suivantes :",
                name: "Nom : Pour identifier et personnaliser votre compte.",
                email:
                    "Adresse e-mail : Pour communiquer avec vous, envoyer des mises à jour et vérifier votre compte.",
                phone:
                    "Numéro de téléphone : Pour vous connecter avec vos contacts et à des fins de sécurité.",
                profile:
                    "Photo de profil : Pour personnaliser votre compte.",
                contacts:
                    "Contacts : Avec votre consentement, nous pouvons accéder à votre liste de contacts afin de vous aider à vous connecter avec vos amis qui utilisent également DazWay.",
            },

            authentication: {
                identifier:
                    "Votre identifiant d’authentification est utilisé pour authentifier votre accès à DazWay sur",
                identifierId:
                    "et pour vous identifier de manière unique.",
                twoFactor:
                    "Vous aurez la possibilité de configurer l’authentification à deux facteurs (2FA) afin de sécuriser votre compte. Pour la 2FA par SMS, nous aurons besoin de votre numéro de téléphone. Ces informations seront partagées avec un fournisseur de services SMS.",
            },
            homeAccountSetup: {
                title: "Configuration du compte DazWay Home",

                desc1:
                    "Lors de la configuration d’un compte DazWay Home via l’assistant de configuration, nous accéderons temporairement aux données de votre compte afin de migrer votre compte DazWay existant vers votre nouveau compte DazWay Home. Cela inclut :",

                joinedGroups:
                    "Liste des groupes que vous avez rejoints",

                powerLevels:
                    "Niveaux d’autorisation dans ces groupes",

                avatar:
                    "Votre avatar",

                desc2:
                    "L’assistant de configuration demandera également votre OpenID et votre jeton d’accès afin de récupérer votre nom ainsi que votre numéro de téléphone vérifié et/ou votre adresse e-mail. Ces informations seront temporairement envoyées à notre backend, mais ne seront pas conservées après la fin de votre configuration.",
            },

            connectionInfo: {
                title: "2.2.2 Informations que nous collectons automatiquement lorsque vous utilisez le service :",
                subTitle: "Informations de connexion",
                desc:
                    "Nous enregistrons les adresses IP de toutes les personnes qui accèdent à DazWay. Ces données sont utilisées afin de prévenir les abus, résoudre les problèmes opérationnels et surveiller les modèles de trafic. Nos journaux sont conservés pendant :",
                desc2:
                    "180 jours, pour les adresses IP de l’application DazWay Super Chat ;",
            },

            usageInfo: {
                title: "Informations d’utilisation",
                desc1:
                    "Nous suivons les données d’utilisation des services d’hébergement DazWay. Lorsque vous êtes connecté à votre compte, nous pouvons suivre votre utilisation du site et associer ces informations aux détails de votre compte. Ces données nous aident à comprendre comment nos utilisateurs utilisent l’application afin d’améliorer le Service.",
                desc2:
                    "Si vous utilisez l’application de chat DazWay, il vous sera demandé d’accepter cette collecte de données anonymisées. Votre utilisation du Service ne dépend pas de cette acceptation. Lorsque vous utilisez l’un des clients de chat DazWay après avoir accepté, votre visite sur le service sera enregistrée avec l’identifiant et l’agent de votre appareil. Cela nous permet de comprendre les habitudes d’utilisation selon chaque plateforme. La correspondance de ces données est conservée pendant 28 jours — après cette période, seules les données agrégées sont conservées à des fins opérationnelles et statistiques. Pour plus de détails sur notre collecte et utilisation des données analytiques, veuillez consulter notre Politique relative aux cookies.",
                desc3:
                    "Lors du signalement d’erreurs, nous pouvons collecter certaines informations afin de nous aider à trouver une solution. Cela peut inclure votre adresse IP, votre nom d’hôte, votre nom complet et votre adresse e-mail. Ces informations sont collectées dans la plateforme de surveillance des applications Sentry et sont soumises à des politiques strictes de conservation."
            },

            locationInfo: {
                title: "Informations de localisation",
                desc1:
                    "Nous pouvons collecter des données de localisation vous concernant si vous choisissez d’utiliser les fonctionnalités de partage de localisation statique ou en direct dans l’application DazWay. Cela inclut vos données de longitude, d’altitude et de latitude afin de calculer précisément votre position.",
                desc2:
                    "Les données de localisation sont conservées dans le groupe dans lequel elles sont partagées. Elles seront donc chiffrées dans les salons chiffrés et non chiffrées dans les salons où le chiffrement est désactivé. Un avertissement vous sera présenté lors de votre première utilisation de cette fonctionnalité, mais veuillez faire preuve de prudence et de réflexion lorsque vous partagez vos données personnelles dans l’application.",
                desc3:
                    "Les clients DazWay utilisent le service tiers MapTiler pour fournir les images utilisées pour afficher les cartes."
            },
            sharingData: {
                title:
                    "2.3. Partage des données conformément aux demandes des autorités compétentes et aux lois applicables ; Protection de nos droits",

                desc1:
                    "Dans des circonstances exceptionnelles, nous pouvons partager des informations vous concernant avec un tiers si nous estimons raisonnablement que ce partage est nécessaire pour :",

                lawCompliance:
                    "Se conformer à toute loi, réglementation, procédure judiciaire ou demande gouvernementale applicable,",

                securityProtection:
                    "Protéger la sécurité ou l’intégrité de nos produits et services (par exemple, dans le cadre d’un audit de sécurité),",

                protectUsers:
                    "Protéger DazWay et nos utilisateurs contre tout préjudice ou activité illégale, ou",

                emergencyResponse:
                    "Répondre à une situation d’urgence lorsque nous estimons de bonne foi qu’il est nécessaire de divulguer des informations afin d’aider à prévenir des blessures graves à toute personne.",
            },

            passwords: {
                title: "2.4 Comment gérons-nous les mots de passe ?",
                desc1:
                    "Nous ne stockons jamais les mots de passe en texte brut ; ils sont plutôt stockés sous forme hachée (avec au moins 12 tours de bcrypt, incluant à la fois un sel et un secret pepper côté serveur). Les mots de passe envoyés au serveur sont chiffrés à l’aide de SSL.",
                desc2:
                    "Il est de votre seule responsabilité de conserver votre nom d’utilisateur, votre mot de passe et toute autre information sensible de manière confidentielle. Les actions effectuées à l’aide de vos identifiants seront considérées comme ayant été effectuées par vous, avec toutes les conséquences associées, y compris la résiliation du service ainsi que des sanctions civiles et pénales.",
                desc3:
                    "Si vous prenez connaissance d’une utilisation non autorisée de votre compte ou de toute autre violation de sécurité, vous devez en informer immédiatement DazWay en envoyant un e-mail à",
                desc4:
                    "Les utilisateurs doivent adopter de bonnes pratiques de gestion des mots de passe (par exemple, utiliser un gestionnaire de mots de passe) et changer leur mot de passe s’ils pensent que leur compte a été compromis.",
                desc5:
                    "Si vous oubliez votre mot de passe (et que vous avez enregistré une adresse e-mail), vous pouvez utiliser la fonctionnalité de réinitialisation du mot de passe pour le réinitialiser."
            },

            childrenPrivacy: {
                title:
                    "2.5 Protection de la vie privée des enfants",
                desc:
                    "Nous ne collectons pas sciemment des données d'utilisateurs de moins de 16 ans.",
            },

            accessCorrect: {
                title:
                    "2.6 Comment accéder ou corriger mes informations ?",
                desc:
                    "Vous pouvez demander une copie de vos données par e-mail.",
            },

            guidelines: {
                title:
                    "2.7. Quelles sont les directives suivies par DazWay lors de l’accès à mes données ?",

                desc1:
                    "Nous limitons l’accès aux données non chiffrées de DazWay aux employés et sous-traitants de DazWay dont les fonctions nécessitent cet accès afin de maintenir le bon fonctionnement des applications et services DazWay.",

                desc2:
                    "Nous ne partageons jamais ce que nous voyons avec d’autres utilisateurs ou le grand public.",
            },

            whoHasAccess: {
                title: "2.8. Qui d’autre a accès à mes données ?",

                desc1:
                    "Nous hébergeons les services DazWay sur Amazon Web Services (AWS), plus précisément :",

                adminServer:
                    "Notre serveur d’administration est hébergé dans un centre de données AWS en Irlande",

                deploymentServer:
                    "Notre serveur de déploiement est hébergé dans un centre de données AWS en Irlande.",

                desc2:
                    "Les employés d’Amazon peuvent avoir accès à certaines de ces données. Voici la politique de confidentialité d’Amazon. Amazon contrôle l’accès physique à ses sites.",
            },

            dataProtection: {
                title:
                    "2.10. Comment mes données sont-elles protégées des données d’un autre utilisateur ?",

                desc1:
                    "Toutes les données des utilisateurs DazWay résident au sein du même cluster dédié. Nous appliquons les meilleures pratiques logicielles afin de garantir que seul le Client puisse y accéder. En d’autres termes, nous segmentons les données des utilisateurs par logiciel. Nous faisons de notre mieux et sommes très confiants dans notre travail, mais, comme tout autre service hébergeant les données des utilisateurs dans la même base de données, nous ne pouvons garantir une protection totale contre une attaque sophistiquée.",
            },
            security: {
                title:
                    "2.12 Que dois-je faire si je découvre une vulnérabilité de sécurité dans le service ?",
                desc1:
                    "Si vous avez découvert un problème de sécurité, veuillez nous envoyer un e-mail à",
                desc2:
                    "Nous travaillerons avec vous afin de nous assurer que nous comprenons l’étendue du problème et que nous traitons entièrement votre préoccupation. La sécurité des informations est notre priorité absolue, et nous nous efforçons de résoudre tout problème aussi rapidement que possible.",
                desc3:
                    "Veuillez agir de bonne foi envers la confidentialité et les données de nos utilisateurs lors de votre divulgation. Les chercheurs en sécurité éthique (white hat) sont toujours appréciés.",
            },
            reportStatus: {
                title:
                    "2.13 Comment un utilisateur peut-il signaler une mise à jour de statut (Stories) ?",
                policyTitle: "La politique :",
                policyDesc:
                    "Tout comme pour les messages standard, d’autres utilisateurs ou des tiers peuvent signaler vos mises à jour de statut à Dazway pour d’éventuelles violations des Conditions d’utilisation ou des lois locales.",
                actionTitle: "Mesure prise :",
                actionDesc:
                    "Lorsqu’un signalement est soumis, les systèmes de sécurité de Dazway collectent des informations sur la partie signalante et l’utilisateur signalé, y compris les mises à jour de statut associées, afin d’enquêter sur la violation.",
            },
        },

        complaint: {
            title: "3. Déposer une plainte",
            desc1:
                "Nous nous efforçons de respecter les normes les plus élevées lors de la collecte et de l’utilisation des informations personnelles. Pour cette raison, nous prenons très au sérieux toutes les plaintes que nous recevons. Nous encourageons les personnes à nous signaler à",
            desc2:
                "si elles estiment que notre collecte ou utilisation des informations est injuste, trompeuse ou inappropriée. Nous accueillons également avec plaisir toute suggestion visant à améliorer nos procédures.",
            desc3:
                "Si vous souhaitez déposer une plainte concernant la manière dont nous avons traité vos informations personnelles auprès de l’autorité de contrôle compétente, vous pouvez contacter l’ICO (l’organisme statutaire chargé de superviser la législation sur la protection des données) à"
        },
    },

    terms: {
        title: "Conditions générales - Application DazWay",

        effectiveDate: "Date d'entrée en vigueur :",
        effectiveDateValue: "20 mai 2025",

        intro1:
            "Bienvenue sur l'application DazWay, une application mobile multifonctionnelle fournie par Pareza Limited, une société enregistrée au Royaume-Uni, dont le siège social est situé au 7 Bell Yard, Londres, Angleterre, WC2A 2JR (« nous », « notre » ou « nos »).",

        intro2:
            "En utilisant l'application DazWay, vous acceptez d'être lié par ces conditions générales, ainsi que par notre politique de confidentialité. Si vous n'êtes pas d'accord, veuillez ne pas utiliser l'application.",

        eligibility: {
            title: "1. Éligibilité",

            desc1:
                "Vous devez avoir au moins 13 ans pour utiliser l'application DazWay. Si vous n'avez pas atteint l'âge de la majorité légale dans votre pays, vous devez utiliser l'application sous la surveillance et avec le consentement d'un parent ou d'un tuteur légal.",
        },

        services: {
            title: "2. Description des services",

            desc1:
                "L'application DazWay offre une large gamme de fonctionnalités de communication numérique et de style de vie, notamment :",

            instantMessaging: "Messagerie instantanée (Chat)",

            voiceVideoCalling: "Appels vocaux et vidéo",

            airtimeTopup:
                "Recharge de crédit téléphonique (via une intégration tierce)",

            marketplace:
                "Place de marché pour les biens et services",

            publicNews:
                "Actualités publiques et annonces",

            ekyc:
                "Fonctionnalités de vérification d'identité (eKYC)",

            desc2:
                "L'application peut évoluer avec de nouvelles fonctionnalités ou services ajoutés, modifiés ou supprimés au fil du temps.",
        },

        registration: {
            title: "3. Enregistrement du compte",

            desc1:
                "Pour utiliser certaines fonctionnalités, les utilisateurs doivent créer un compte en fournissant des informations exactes et complètes. Vous êtes seul responsable du maintien de la sécurité de vos identifiants de connexion et de toute activité sous votre compte.",

            desc2:
                "Nous nous réservons le droit de suspendre ou de résilier votre compte à notre discrétion en cas de mauvaise utilisation, de fraude ou de violation des présentes conditions.",
        },

        acceptableUse: {
            title: "4. Politique d'utilisation acceptable",

            desc1:
                "Lors de l'utilisation de l'application DazWay, vous acceptez ce qui suit :",

            illegalContent:
                "Ne pas partager de contenu illégal, abusif, violent ou trompeur",

            harassment:
                "Ne pas harceler, menacer ou usurper l'identité d'autrui",

            rightsViolation:
                "Ne pas violer les droits d'autrui (ex. propriété intellectuelle, vie privée)",

            appSecurity:
                "Ne pas interférer avec ou compromettre la sécurité ou la fonctionnalité de l'application",

            desc2:
                "Toute violation de cette politique peut entraîner la suspension du compte ou son retrait permanent de la plateforme.",
        },

        marketplace: {
            title: "5. Utilisation de la place de marché",

            desc1:
                "La place de marché de l'application DazWay permet aux utilisateurs de parcourir, publier ou promouvoir des biens et services.",

            noParty:
                "Nous n'intervenons pas en tant que partie aux transactions, sauf indication contraire.",

            userResponsibility:
                "Les utilisateurs sont seuls responsables de l'exactitude et de la légalité de leurs annonces.",

            disputes:
                "Nous ne sommes pas responsables des litiges entre acheteurs et vendeurs, bien que nous puissions aider à la médiation dans la mesure du possible.",
        },

        intellectualProperty: {
            title: "6. Propriété intellectuelle",

            desc1:
                "Tous les éléments de l'application DazWay, y compris les logiciels, textes, images, graphiques et logos sont la propriété de Pareza Limited ou de tiers sous licence.",

            desc2:
                "Vous ne pouvez pas copier, reproduire, modifier ou distribuer une partie de l'application sans l'autorisation écrite de Pareza Limited.",
        },

        privacyData: {
            title: "7. Confidentialité et données",

            desc1:
                "Nous prenons la vie privée des utilisateurs au sérieux. Vos données personnelles sont collectées et traitées conformément à notre politique de confidentialité. Cela comprend les données d'identité pour la vérification de l'utilisateur, l'historique des communications et les journaux d'utilisation à des fins opérationnelles et de sécurité.",

            desc2:
                "Les données peuvent être traitées et stockées en dehors de votre pays de résidence, conformément aux lois applicables sur la protection des données.",
        },

        availability: {
            title: "8. Disponibilité et modifications",

            desc1:
                "Nous nous efforçons de maintenir un accès continu à l'application, mais nous ne garantissons pas une disponibilité ininterrompue. Nous pouvons mettre à jour, suspendre ou interrompre certaines fonctionnalités à tout moment sans préavis.",

            desc2:
                "Nous ne sommes pas responsables des pertes ou dommages causés par pannes ou problèmes techniques.",
        },

        termination: {
            title: "9. Résiliation",

            desc1:
                "Nous nous réservons le droit de résilier ou de suspendre votre accès à l'application DazWay à notre discrétion, avec ou sans préavis, en particulier en cas de violation de ces conditions ou des lois applicables.",

            desc2:
                "Vous pouvez supprimer votre compte à tout moment en utilisant les options de l'application ou en contactant l'assistance.",
        },

        disclaimer: {
            title: "10. Exclusion de garantie et limitation de responsabilité",

            desc1:
                "L'application DazWay est fournie « en l'état » et « selon disponibilité ».",

            desc2:
                "Dans la mesure maximale autorisée par la loi, Pareza Limited décline toute responsabilité pour :",

            dataLoss:
                "La perte de données ou de contenu",

            serviceInterruptions:
                "L'indisponibilité ou les interruptions de service",

            misconduct:
                "Les dommages résultant d'une mauvaise conduite de l'utilisateur ou d'actions de tiers",

            indirectDamages:
                "Tous dommages indirects, accessoires ou consécutifs",
        },

        changes: {
            title: "11. Modifications de ces conditions",

            desc1:
                "Nous pouvons réviser ces conditions de temps à propre. Les utilisateurs seront informés via l'application ou par e-mail de tout changement important. L'utilisation continue de l'application DazWay après des modifications constitue votre acceptation des nouvelles conditions.",
        },

        governingLaw: {
            title: "12. Droit applicable et juridiction",

            desc1:
                "Ces conditions sont régies par les lois du Royaume-Uni. Tout litige sera soumis à la juridiction exclusive des tribunaux situés à Londres, Angleterre.",
        },

        contact: {
            title: "13. Contactez-nous",

            desc1:
                "Pour des questions, de l'assistance ou des préoccupations juridiques, veuillez contacter :",

            company: "Pareza Limited",

            address:
                "7 Bell Yard, Londres, Angleterre, WC2A 2JR",

            emailLabel: "E-mail :",
        },
    },

    deleteAccount: {
        title: "Comment supprimer définitivement votre compte DazWay",

        desc1:
            "Voici les étapes pour supprimer définitivement votre compte de l'application mobile DazWay :",

        step1:
            "Connectez-vous à votre compte DazWay sur l'application mobile.",

        step2:
            "Accédez à la page Paramètres en appuyant sur l'icône Paramètres située en bas à droite de l'écran.",

        step3:
            "Appuyez sur « Supprimer mon compte ».",

        step4:
            "Saisissez votre numéro de mobile enregistré et vérifiez-le à l'aide de l'OTP envoyé à votre numéro.",

        step5:
            "Sélectionnez un motif pour la suppression de votre compte.",

        step6:
            "Appuyez sur « Supprimer mon compte ».",

        step7:
            "Dans le popup de confirmation, appuyez sur « OK ».",

        desc2:
            "Une fois confirmé, votre compte sera définitivement supprimé de la plateforme DazWay.",
    },

    createAndSharePost: {
        newChat: {
            title: "Démarrer une nouvelle discussion",
            intro: "Pour commencer une conversation :",
            step1: "Appuyez sur l'icône de discussion dans la barre de navigation inférieure.",
            step2: "Appuyez sur l'icône (+) au centre-bas de l'écran.",
            step3: "Parmi les options affichées (Discussion, Groupe+, Réunion), sélectionnez Discussion.",
            step4: "Choisissez un utilisateur dans Mes Contacts (contacts enregistrés dans votre répertoire téléphonique).",
            step5: "Vous serez redirigé vers l'écran de discussion pour commencer la conversation."
        },
        chatFunc: {
            title: "Fonctionnalités de discussion",
            intro: "Une fois dans un écran de discussion, vous pouvez :",
            sendMessagesLabel: "Envoyer des messages",
            sendMessagesDesc: " – Saisissez votre message et appuyez sur l'icône d'envoi.",
            capturePhotoVideoLabel: "Prendre une photo/vidéo",
            capturePhotoVideoDesc: " – Appuyez sur l'icône de l'appareil photo, ou utilisez Pièce jointe > Appareil photo.",
            shareGalleryMediaLabel: "Partager des médias de la galerie",
            shareGalleryMediaDesc: " – Utilisez Pièce jointe > Galerie.",
            sendDocumentsLabel: "Envoyer des documents",
            sendDocumentsDesc: " – Utilisez Pièce jointe > Document.",
            sendAudioFilesLabel: "Envoyer des fichiers audio",
            sendAudioFilesDesc: " – Utilisez Pièce jointe > Audio.",
            shareContactsLabel: "Partager des contacts",
            shareContactsDesc: " – Utilisez Pièce jointe > Contacts.",
            sendLocationLabel: "Envoyer la position",
            sendLocationDesc: " – Utilisez Pièce jointe > Position.",
            sendEmojisLabel: "Envoyer des émojis",
            sendEmojisDesc: " – Appuyez sur l'icône Émoji et sélectionnez l'émoji de votre choix."
        },
        groupChat: {
            title: "Discussion de groupe",
            startIntro: "Pour démarrer une discussion de groupe :",
            startStep1: "Appuyez sur l'icône de discussion dans la barre de navigation inférieure.",
            startStep2: "Appuyez sur l'icône (+) au centre-bas de l'écran.",
            startStep3: "Parmi les options affichées (Discussion, Groupe+, Réunion), sélectionnez Groupe+.",
            startStep4: "Choisissez plusieurs utilisateurs de Mes Contacts à ajouter au groupe.",
            startStep5: "Saisissez le nom du groupe et appuyez sur Créer le groupe.",
            startStep6: "Vous serez redirigé vers le nouvel écran de discussion de groupe où vous pourrez commencer à envoyer des messages.",
            actionsIntro: "Dans une discussion de groupe, vous pouvez :",
            actionStep1: "Envoyer des messages, des médias, des documents et des notes vocales à tous les membres.",
            actionStep2: "Mentionner des membres spécifiques en utilisant ",
            actionStep2Suffix: ".",
            actionStep3: "Afficher la liste des participants en appuyant sur la section Infos du groupe.",
            actionStep4: "Ajouter ou supprimer des membres (si vous êtes l'administrateur du groupe).",
            actionStep5: "Personnaliser le nom du groupe, l'image et les paramètres."
        }
    },

    exploreAndViewPost: {
        newCall: {
            title: "Passer un nouvel appel",
            intro: "Pour lancer un nouvel appel :",
            step1: "Appuyez sur l'icône Appel dans la barre de navigation inférieure.",
            step2: "Appuyez sur l'icône (+) dans le coin inférieur droit.",
            step3: "Sélectionnez votre option préférée : Appel audio, Appel vidéo ou Réunion.",
            step4: "Choisissez un contact dans Mes Contacts.",
            step5Before: "Appuyez sur",
            step5Label: "Appeler maintenant",
            step5Desc: "pour lancer l'appel."
        },
        groupCalls: {
            title: "Appels de groupe",
            intro: "Pour démarrer un appel audio ou vidéo de groupe :",
            step1: "Appuyez sur l'icône Appel > icône (+) > Groupe +.",
            step2: "Sélectionnez plusieurs contacts dans votre liste.",
            step3: "Choisissez",
            step3Strong1: "Appel audio",
            step3Or: "ou",
            step3Strong2: "Appel vidéo",
            step4Before: "Appuyez sur",
            step4Label: "Appeler maintenant",
            step4Desc: "pour lancer l'appel de groupe."
        }
    },

    chatAndCalls: {
        meetings: {
            title: "Réunions",
            intro: "Pour créer ou rejoindre une réunion :",
            step1: "Appuyez sur l'icône Discussion ou Appel.",
            step2Before: "Appuyez sur l'icône (+) et sélectionnez",
            step2Strong: "Réunion",
            step3: "Saisissez les détails requis de la réunion et invitez les participants.",
            step4Before: "Appuyez sur",
            step4Strong1: "Démarrer la réunion",
            step4Or: "ou",
            step4Strong2: "Planifier",
            step4Suffix: ", selon la disponibilité."
        }
    },

    footer: {
        copyright: "2026 © DazWay Pay Limited"
    }
};